import type { UserColor } from '@kominiarz/shared';
import styles from './ColorDot.module.css';

/** The person's calendar colour, e.g. next to their name. */
export function ColorDot({ color, size = 'md' }: { color: UserColor; size?: 'sm' | 'md' }) {
  return (
    <span
      className={`${styles.dot} ${styles[size]}`}
      style={{ background: `var(--user-${color})` }}
      aria-hidden="true"
    />
  );
}
